import dateUtil from "./dateUtil"
import htmlPageUtil from "./htmlPageUtil"
import type from "./typeUtil"
import commonUtil, {
  stringArrayToComponent,
  stringArrayToListComponent,
} from "./commonUtil"

const util = {
  date: dateUtil,
  htmlPage: htmlPageUtil,
  type: type,
  stringArray: {
    toComponent: stringArrayToComponent,
    toListComponent: stringArrayToListComponent,
  },
  ...commonUtil,
}

export default util
